import {Component, inject, output} from '@angular/core';
import {InAppMessage} from "../../models/inAppMessage";
import {RepoService} from "../../services/repo.service";
import {MatDrawer} from "@angular/material/sidenav";
import {AsyncPipe, DatePipe} from "@angular/common";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {MatTab, MatTabGroup} from "@angular/material/tabs";
import {SiteMessage} from "../../models/site-message";
import {toSignal} from "@angular/core/rxjs-interop";

@Component({
  selector: 'app-previous-site-messages',
  imports: [
    DatePipe,
    MatMenu,
    MatMenuItem,
    MatTab,
    MatTabGroup,
    AsyncPipe,
    MatMenuTrigger
  ],
  templateUrl: './previous-site-messages.component.html',
  styleUrl: './previous-site-messages.component.css'
})
export class PreviousSiteMessagesComponent {

  drawer = inject(MatDrawer);
  repoService = inject(RepoService);

  copyMessage = output<SiteMessage>();

  messages: InAppMessage[] = [];

  favorites = toSignal(this.repoService.listenToSiteMessageFavorites(), {initialValue: []})
  history$ = this.repoService.getSiteMessageHistory();


  constructor() {
    console.log(this.favorites())
  }

  addToFavorites(message: SiteMessage) {
    this.repoService.addToSiteMessageFavorites(message)
  }

  delete(message: SiteMessage) {
    this.repoService.deleteFavoriteSiteMessage(message)
  }

}
